export const downloadFile = (data: Blob, fileName: string, fileType: 1 | 2) => {
  const blobUrl = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = blobUrl
  link.setAttribute(
    'download',
    `${fileName}.${fileType === 1 ? 'xlsx' : 'pdf'}`
  )
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export const downloadFileFromUrl = async (url: string, fileName: string) => {
  const response = await fetch(url, { credentials: 'include' })
  if (!response.ok) {
    throw new Error(String(response.status))
  }
  const blob = await response.blob()
  const blobUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = blobUrl
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(blobUrl)
}
